import type { TechpackState } from './techpack.types'

export const state: TechpackState = {
  techpack: undefined,
  loading: false
}
